import { FC } from "react";
import { Modal } from '@sainsburys-tech/luna-modal'
import { PopupType } from "../../../Interfaces/IModalProps";
import ProductFields from "./productFields";
import store from "../../../Store/store";
import { storePageDirtyPayload } from "../../../Redux/Actions/pageDirtyAction";
import { useSelector } from "react-redux";
import ProductFoodVolumetricsFields from "./productFoodVolumetricsFields";

const ProductModal: FC<PopupType> = ({
    isOpen,
    handleClose,
    handleAddCallback: handleAdd,
    title,
    isEdit
}) => {
    const selectedMenuFromFilterReducer = useSelector(
        (state: any) => state.filterReducer.data
    );

    const closeHandler = () => {
        store.dispatch(storePageDirtyPayload(null))
        handleClose(false)
    }

    return (
        <div className="duTypeModal">
            <Modal
                classNanme="duTypeModal"
                small
                handleClose={() => closeHandler()}
                open={isOpen}
                headingId="info-modal"
                stickyHeader="Sticky Header"
                restrictClose={true}
            >
                {
                    selectedMenuFromFilterReducer?.selectedMenu === "Food Volumetrics"
                        ? <ProductFoodVolumetricsFields closeModal={closeHandler} isEdit={isEdit} />
                        : <ProductFields closeModal={closeHandler} isEdit={isEdit} />
                }
            </Modal>
        </div>
    )
}
export default ProductModal;